<template lang="pug">
include ../pug/svg
main#signin(:class="{spacer:!allowSignup}")
	p#signup(v-if="allowSignup")
		span Don't have an account?
		AppLink.but.sec(:to="{name:'Signup'}") Get Started
	div.form(:class="{step1:!identified,step2:identified,forgotten:forgotten===1,forgotten2:forgotten===2}")
		img(id="imgLoader" ref="imgLoader")
		Form(:validation-schema="schemaIdentify" v-slot="{ errors, isSubmitting, values, meta }" @submit="doIdentify")
			h1 {{terminology('interface','signin','singular')}} to {{gui.organisation.name}}
			p
				span.err(v-if="errors.email") {{ errors.email }}
				span(v-else) Let's identify you&hellip;
			FieldText(name="email" type="email" :label="emailLabel" :required="true" autocomplete="on")
				
			span.req(aria-hidden="true") Required
			button.but.pri.spinner(:class="{'spin':isSubmitting}" :disabled="!values.email||!meta.valid||isSubmitting" type="submit") Next
				+svg(svg-filename="spinner" aria-hidden="true" alt="Processing")
				
		Form(ref="formSignin" v-if="identified" :validation-schema="schemaSignin" v-slot="{ errors, isSubmitting, values, meta }" @submit="doSignin")
			picture(v-if="user.profileUrl" aria-hidden="true")
				img(:src="user.profileUrl" :alt="user.fullName" width="150" height="150")
			p.alt(v-else aria-hidden="true") {{user.initials}}

			p.h1 Welcome {{user.firstName}}
			p(v-if="forgotten===2")
				span.err(v-if="errors.securityAnswer2") {{ errors.securityAnswer2 }}
				span(v-else) And finally, {{user.securityQuestion2.toLowerCase()}}
			p(v-else-if="forgotten===1")
				template(v-if="emailUser")
					span.err(v-if="errors.passcode") {{ errors.passcode }}
					span(v-else) We've emailed a passcode to your inbox&hellip;
				template(v-else)
					span.err(v-if="errors.securityAnswer1") {{ errors.securityAnswer1 }}
					span(v-else) Okay, {{user.securityQuestion1.toLowerCase()}}
			p(v-else)
				span.err(v-if="errors.password") {{ errors.password }}
				span(v-else) Let's get you signed in&hellip;
			div.wrap
				div.fieldwrap
					FieldText(name="password" type="password" v-model="password" label="Password" :required="true")
					//-button.but.eye(type="button" @click="togglePasswordType") {{ passwordState }} Password
						+svg(svg-filename="iconHide" aria-hidden="true" alt="Show icon")

				div.fieldwrap
					div.field.req(v-if="emailUser")
						Field(name="passcode" type="text" value="" placeholder="Unsupplied" autocomplete="off")
						label(for='passcode') Passcode
					template(v-else)
						FieldText(name="forgotten" type="hidden" v-model="forgotten")
						FieldText(name="securityAnswer1" label="Answer to Security Question 1" v-model="securityAnswer1" :required="true" :validateOnInput="true")
					//-div.field.req(v-else)
						FieldText(name="forgotten" type="hidden" v-model="forgotten")
						Field(name="securityAnswer1" type="text" value="" placeholder="Unsupplied" autocomplete="off")
						label(for='securityAnswer1') Answer to Security Question 1

				div.fieldwrap
					//-div.field.req(v-if="forgotten===2")
						Field(name="securityAnswer2" type="text" value="" placeholder="Unsupplied" autocomplete="off")
						label(for='securityAnswer2') Answer to Security Question 2
					FieldText(name="securityAnswer2" label="Answer to Security Question 2" v-model="securityAnswer2" :required="true")
						
			//-p.forgot(:class="{show:errors.password||errors.passcode}")
			p.forgot.show
				//-a(:class="{hide:!forgotten}" role="button" @click="undoForgot()") Cancel
				a(:class="{hide:!forgotten}" role="button" @click="undoForgot()") Cancel
				a(:class="{hide:forgotten}" @click="doForgot()") Forgotten your password?

			span.req(aria-hidden="true") Required
			button.but.pri.spinner(:class="{'spin':isSubmitting}" :disabled="!meta.valid||isSubmitting" type="submit") {{signinButtonLabel}}
				+svg(svg-filename="spinner" aria-hidden="true" alt="Processing")
	Copyright
</template>

<script>
import AuthService from '../services/AuthService';
import Copyright from '../components/Copyright';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import FieldText from '../components/FieldText';

export default {
	name: 'Signin',
	components: {
		Copyright,
		Form,
		Field,
		ErrorMessage,
		FieldText,
	},
	data() {
		return {
			user: null,
			identified: false,
			authenticated: false,
			forgotten: 0,
			// not null
			emailUser: false,
			securityAnswer1: '',
			securityAnswer2: '',
			password: '',
		};
	},
	setup() {
		const schemaIdentify = Yup.object().shape({
			email: Yup.string().test('emailOrUsername', 'Oops, that\'s an invalid email or username!', (value) => {
				if (value) {
					return value.includes('@') ? Yup.string().email().isValidSync(value) : Yup.string().matches(/^[\w-]+$/).isValidSync(value); 
				}
				
				return false;
				
			}).required('Required'),
		});
		
		const req = 'Required';
		const schemaSignin = Yup.object().shape({
			password: Yup.string().when(['passcode', 'securityAnswer1'], {
				is: (passcode, securityAnswer1) => !passcode && !securityAnswer1,
				then: Yup.string().required(req)
				//otherwise: Yup.string().required(req),
			}),
			passcode: Yup.string().when(['password', 'securityAnswer1'], {
				is: (password, securityAnswer1) => !password && !securityAnswer1,
				then: Yup.string().required(req)
			}),
			securityAnswer1: Yup.string().when(['password', 'passcode'], {
				is: (password, passcode) => !password && !passcode,
				then: Yup.string().required(req)
			}),		
			securityAnswer2: Yup.string().when(['securityAnswer1','forgotten'], {
				is: (securityAnswer1, forgotten) => securityAnswer1 && forgotten === 2,
				then: Yup.string().required(req)
			}),
		}, [ // cast and coerce field associations
			['password', 'passcode'],
			['password', 'securityAnswer1'],
			['passcode', 'securityAnswer1'],
			['securityAnswer1', 'securityAnswer2'],
			['securityAnswer2', 'forgotten'],
		]);
		
		return {
			schemaIdentify,
			schemaSignin,
		}
	},
	mounted() {
		// check for signout request
		if (this.$route.params.signout) {
			this.$store.dispatch('auth/signout');
		} 
	},
	computed: {
		gui() {
			return this.$store.state.gui;
		},
		allowSignup() {
			return this.gui.authScreen.allowSignup;
		},
		emailLabel() {
			return (this.gui.feature.usernames) ? 'Email or Username': 'Email';
		},
		signinButtonLabel() {
			return (this.forgotten === 1) ? 'Next' : 'Sign In';
		},
	},
	methods: {
		togglePasswordType() {
			if (this.passwordType === 'password') {
				this.passwordType = 'text';
				this.passwordState = 'Hide';
			} else {
				this.passwordType = 'password';
				this.passwordState = 'Show';
			}
		},
		async loadImage(url, elem) {
			return new Promise((resolve, reject) => {
				elem.onload = () => resolve(elem);
				elem.onerror = reject;
				elem.src = url;
			});
		},
		terminology(groupKey, termKey, varKey) {
			return this.$store.getters['gui/customTerm'](groupKey, termKey, varKey);
		},
		async doIdentify(formData, actions) {
			try {
				const delay = this.$store.getters['gui/delay'];
				const res = await AuthService.identify(formData);
				
				this.user = res.data.user;
				
				if (this.user.profileUrl) {
					await this.loadImage(this.user.profileUrl, this.$refs.imgLoader);
				}
				
				this.emailUser = this.user.email.includes('@');
				
				await delay;
				
				// step two
				this.identified = true;
				
			} catch(err) {
				if (err.response.status === 404) {
					actions.setFieldError('email', "Oops, we couldn't find your email on this thinkhub!");
				} else if (err.response.status === 403) {						   
					actions.setFieldError('email', err.response.data.message);
				}
			}
		},
		async doSignin(formData, actions) {
			try {
				const delay = this.$store.getters['gui/delay'];
				
				const {data} = await this.$store.dispatch('auth/signin', {
					email: this.user.email,
					password: formData.password || null,
					passcode: formData.passcode || null,
					securityAnswer1: formData.securityAnswer1 || null,
					securityAnswer2: formData.securityAnswer2 || null,
				});
				
				await delay;
				
				if (data.securityAnswer1) {
					// correct first answer
					this.forgotten = 2;	
					
				} else {
					// sign in success
					if (this.$store.state.auth.user.userOrganisations[0].role.slug === 'learner') {
						this.$router.push({name:'Learn', params:{state:'active'}});
					} else {
						this.$router.push({ name: 'ManageLearning' });
					}				
				}
				
			} catch(err) {
				// known or unexpected error
				console.log('ERROR:', err);
				const field = err.response.data.message;
				const msg = (err.response.status === 401) ? 'Oops, that was incorrect, please try again!' : 'Error: '+err.response.status;
				
				actions.setFieldError(field, msg);
			}
		},
		async doForgot() {
			try {
				if (this.emailUser) {
					// email one-time-passcode
					await AuthService.recover({
						email: this.user.email,
					});					
				}
				
				// clear touched state
				this.$refs.formSignin.resetForm();
				
				setTimeout(() => {
					this.forgotten = 1;
				}, 250);
				
			} catch(err) {
				// unexpected error
				this.$refs.formSignin.setFieldError('password', 'Error: '+err.response.status);
			}
		},
		undoForgot() {
			// clear touched state
			this.$refs.formSignin.resetForm();
			this.forgotten = 0;
		},
	},
}
</script>

<style lang="scss">
#signin {
	.form {
		&.step2 {
			&.forgotten {
				.wrap {
					transform: translatex(-33.333%);
				}
			}
			&.forgotten2 {
				.wrap {
					transform: translateX(-66.66%);
				}
			}
			p.forgot {
				position: relative;
				display: flex;
				justify-content: space-between;
				transition: opacity .3s ease-in-out;
				&:not(.show) {
					opacity: 0;
				}
				a.hide {
					pointer-events: none;
					opacity: 0;
				}
			}
		}
	}
	form {
		overflow: hidden;
//		&[ref="formSignin"] {
			/*.but {
				&:after {
					content: 'Next??';
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					color: inherit;
					background: inherit;
					transition: .3s ease-in-out;
				}
			}*/
//		}
	}
	.wrap {
//		width: 200%;
		width: 300%;
		display: flex;
		align-self: flex-start;
		transition: transform .3s ease-in-out;
		.fieldwrap {
			display: flex;
			width: 50%;
			justify-content: center;
			.field {
			}
		}
	}	
}

</style>
